import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {DatePipe} from "@angular/common";
import Subscription from "../../../shared-module/model/subscription.model";
import {SubscriptionStateLabel} from "../../../shared-module/enums/subscription-state-label";
import AddressPipe from "../../../shared-module/pipes/address.pipe";
import {DurationPipe} from "../../../shared-module/pipes/duration.pipe";
import {
  BadgeWithContentComponent
} from "../../../shared-module/components/badge-with-content/badge-with-content.component";
import {SubscriptionState} from "../../../shared-module/enums/subscription-state";
import {CardComponent} from "../../../shared-module/components/card/card.component";

@Component({
    selector: 'app-contract-information',
    imports: [
    BadgeWithContentComponent,
    AddressPipe,
    DatePipe,
    DurationPipe,
    CardComponent
],
    templateUrl: './contract-information.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './contract-information.component.scss'
})
export class ContractInformationComponent {
  @Input() public subscription: Subscription | null = null;

  protected readonly SubscriptionStateLabel: { [key in SubscriptionState]: string } = SubscriptionStateLabel;
  protected readonly SubscriptionState = SubscriptionState;
}
